class AmendmentDocument {
    constructor(id, value, url) {
        this.id = id
        this.value = value
        this.url = url
    }

    static fromJson({ id, name, url }) {
        return new AmendmentDocument(id, name, url)
    }
}

export default AmendmentDocument
